import React from 'react';
import { KeyIcon, HomeIcon, RefreshCwIcon, BuildingIcon, TrendingUpIcon, UnlockIcon, MapIcon, TargetIcon } from 'lucide-react';
const buyerServices = [{
  title: 'First Home Purchase',
  description: 'We help you buy your first home with a clear plan — so you start strong and keep your options open.',
  icon: KeyIcon
}, {
  title: 'Next Home / Upgrade',
  description: 'Moving up? We structure your next purchase to keep your current property or release equity smartly.',
  icon: HomeIcon
}, {
  title: 'Refinance',
  description: "Better rate, better structure, or releasing equity — we find the right fit for where you're headed.",
  icon: RefreshCwIcon
}];
const investorServices = [{
  title: 'First Investment',
  description: 'Your first investment property, structured properly from day one so you can keep going.',
  icon: BuildingIcon
}, {
  title: 'Scaling Your Portfolio',
  description: 'Growing beyond one property? We build the lending strategy to support it — not just the next deal.',
  icon: TrendingUpIcon
}, {
  title: 'Equity Release & Structuring',
  description: 'Unlock equity and restructure loans to fund your next move without overextending.',
  icon: UnlockIcon
}];
export function ServicesSection() {
  return <section id="services" className="py-24 bg-[#f8f9fb] dark:bg-[#0f1629] transition-colors duration-300 relative z-10" data-id="element-412">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-413">
        <div className="text-center mb-16" data-id="element-414">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white dark:bg-white/5 border border-slate-200 dark:border-white/10 shadow-sm dark:shadow-none mb-6" data-id="element-415">
            <span className="text-sm font-medium text-primary-600 dark:text-primary-400" data-id="element-416">
              What We Help With
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4" data-id="element-417">
            Strategy Built Around You
          </h2>
          <p className="text-lg text-slate-500 dark:text-slate-400 max-w-2xl mx-auto" data-id="element-418">
            We don't just help you get a loan — we help you build a strategy
            around it. Every move is designed to set you up for the next one.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-419">
          {/* For Home Buyers */}
          <div data-id="element-420">
            <div className="flex items-center gap-3 mb-8 pb-4 border-b border-slate-200 dark:border-white/10" data-id="element-421">
              <div className="p-2.5 rounded-xl bg-accent-100 dark:bg-accent-500/15 text-accent-600 dark:text-accent-400" data-id="element-422">
                <MapIcon className="w-5 h-5" data-id="element-423" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white" data-id="element-424">
                For Home Buyers
              </h3>
            </div>
            <div className="space-y-4" data-id="element-425">
              {buyerServices.map((service, index) => {
              const Icon = service.icon;
              return <div key={index} className="group p-5 rounded-xl bg-white dark:bg-[#1a2035] border border-slate-200 dark:border-white/5 hover:border-accent-300 dark:hover:border-accent-500/30 transition-all duration-200 shadow-sm hover:shadow-md dark:shadow-none" data-id="element-426">
                    <div className="flex gap-4" data-id="element-427">
                      <div className="flex-shrink-0 mt-0.5" data-id="element-428">
                        <div className="p-2 rounded-lg bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/10 text-slate-400 dark:text-slate-500 group-hover:text-accent-600 dark:group-hover:text-accent-400 group-hover:bg-accent-50 dark:group-hover:bg-accent-500/10 group-hover:border-accent-200 dark:group-hover:border-accent-500/20 transition-colors" data-id="element-429">
                          <Icon className="w-5 h-5" data-id="element-430" />
                        </div>
                      </div>
                      <div data-id="element-431">
                        <h4 className="text-base font-semibold text-slate-900 dark:text-white mb-1.5" data-id="element-432">
                          {service.title}
                        </h4>
                        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed" data-id="element-433">
                          {service.description}
                        </p>
                      </div>
                    </div>
                  </div>;
            })}
            </div>
          </div>

          {/* For Investors */}
          <div data-id="element-434">
            <div className="flex items-center gap-3 mb-8 pb-4 border-b border-slate-200 dark:border-white/10" data-id="element-435">
              <div className="p-2.5 rounded-xl bg-primary-100 dark:bg-primary-500/15 text-primary-600 dark:text-primary-400" data-id="element-436">
                <TargetIcon className="w-5 h-5" data-id="element-437" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white" data-id="element-438">
                For Investors
              </h3>
            </div>
            <div className="space-y-4" data-id="element-439">
              {investorServices.map((service, index) => {
              const Icon = service.icon;
              return <div key={index} className="group p-5 rounded-xl bg-white dark:bg-[#1a2035] border border-slate-200 dark:border-white/5 hover:border-primary-300 dark:hover:border-primary-500/30 transition-all duration-200 shadow-sm hover:shadow-md dark:shadow-none" data-id="element-440">
                    <div className="flex gap-4" data-id="element-441">
                      <div className="flex-shrink-0 mt-0.5" data-id="element-442">
                        <div className="p-2 rounded-lg bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/10 text-slate-400 dark:text-slate-500 group-hover:text-primary-600 dark:group-hover:text-primary-400 group-hover:bg-primary-50 dark:group-hover:bg-primary-500/10 group-hover:border-primary-200 dark:group-hover:border-primary-500/20 transition-colors" data-id="element-443">
                          <Icon className="w-5 h-5" data-id="element-444" />
                        </div>
                      </div>
                      <div data-id="element-445">
                        <h4 className="text-base font-semibold text-slate-900 dark:text-white mb-1.5" data-id="element-446">
                          {service.title}
                        </h4>
                        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed" data-id="element-447">
                          {service.description}
                        </p>
                      </div>
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}